<template>
    <div class="row mb-3">
        <div v-for="$class in classes" :class="cssClasses" v-on:click="toggleSelected($class.id)">
            <div class="card class-card py-2 position-relative overflow-hidden "
                 :class="[$class.color, (selectedClasses.includes($class.id) ? 'selected' : '')]">
                <div class="position-absolute w-100 h-100 top-0 left-0 bg-light-blue op-0-6 mt-auto check-overlay">
                    <div class="d-flex h-100 justify-content-center align-content-center ">
                        <i class="fs-1 mt-auto mb-auto fi fi-rr-check "></i>
                    </div>
                </div>
                <div class="card-body">
                    <div class="mr-2 h-auto">
                        <div class="class-name">
                            <div class="title large">{{ $class.name }}</div>
                            <div>
                                <img :src="`/img/class-icons/${$class.color}-${$class.icon}.svg`">
                            </div>
                        </div>

                        <p :class="['class-schedule', {'text-dark-red text-decoration-line-through': $class.level?.deleted_at } ]" v-html="$class.level?.label"></p>
                    </div>
                    <div class="children">
                        <div class="number">
                            <i class="fi fi-rr-smile text-gray-400"></i>
                            <label>
                                {{ $class.children_count }} {{ trans('general.defaults.children_count') }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-center">
            <div class="btn btn-open btn-secondary " ref="show_more" v-on:click="showMore">
                <span class="text">Show more</span>
            </div>
        </div>
        <input type="hidden" :name="name || (single ? 'group_id' : 'classes')"
               :value="single ? selectedClasses[0] || '' : JSON.stringify(selectedClasses)">
    </div>
</template>

<script>
export default {
    name: "ClassSelection",
    props: {
        selected: null,
        single: Boolean,
        required: Boolean,
        name: String,
        page: Number,
        limit: Number,
        css: Array
    },
    data() {
        return {
            classes: [],
            pageNum: this.page ?? 1,
            size: this.selected ? (this.limit || 3) - 1 : (this.limit || 3),
            selectedClasses: [],
            cssClasses: ['col-md-6 col-lg-6 col-xl-3 mb-3']
        }
    },
    watch: {
        selectedClasses: function (val) {
            this.$emit( 'change', val)
        },
        classes: function (val) {
            if(val.length === this.selectedClasses.length) {
                this.$emit( 'allClassesSelected', true)
            }
        }
    },
    methods: {
        load() {
            const params = {limit: this.size, page: this.pageNum, include: 'level'};

            if (this.selected && !Array.isArray(this.selected) && this.classes.length === 0) {
                params.except_id = this.selected
                axios.get(`/classes/${this.selected}`, {params: {include: 'level'}})
                    .then((response) => {
                        let data = response.data.data;
                        this.classes = [data];
                        this.$emit( 'allClassesSelected', this.classes === this.selectedClasses.length)
                    });
            }

            axios.get(`/classes`, {params})
                .then((response) => {
                    let data = response.data.data;
                    this.classes = [...this.classes, ...data.data];

                    if (data.last_page === this.pageNum) {
                        this.$refs.show_more.remove();
                    }
                });
        },
        showMore() {
            this.pageNum = this.pageNum + 1;
            this.load()
        },
        reload() {
            this.pageNum = 1;
            this.reviews = [];
            this.read();
        },
        toggleSelected: function (el) {
            if (this.single) {
                this.selectedClasses = [el];
                return;
            }
            const index = this.selectedClasses.indexOf(el);

            if (index > -1) {
                if (this.selectedClasses.length === 1 && this.required) {
                    this.$notify({type: 'warn', text: trans('general.page.classes.class_menu.validate_message')});
                    return;
                }
                this.selectedClasses.splice(index, 1);
            } else {
                this.selectedClasses.push(el);
            }
        }
    },
    mounted() {
        if (this.selected) {
            this.selectedClasses = Array.isArray(this.selected)
                ? this.selected.map(v => v.id || v) : [this.selected?.id || this.selected ];
        }
        if (this.css) {
            this.cssClasses = this.css;
        }

        this.load()
    }
}
</script>

<style scoped>
.class-card:not(.selected) {
    opacity: .4;
}

.class-card:not(.selected) img {
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    filter: grayscale(100%);
}

.class-card.selected {
    background: #ECF9F3;
    border-color: #52C794 !important;
}
</style>
